import { render, staticRenderFns } from "./tree_new.vue?vue&type=template&id=3365bf13"
import script from "./tree_new.vue?vue&type=script&lang=ts"
export * from "./tree_new.vue?vue&type=script&lang=ts"
import style0 from "./tree_new.vue?vue&type=style&index=0&id=3365bf13&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports